import React from 'react';
import { getHeader, getExplore, getSchool, getCommunityInfo, getIdentity, getPriceTable, getBanner } from 'src/api';
import { translationsParser } from 'src/config/translations/translationsParser';
import { LayoutCommunity } from 'src/components/escuela';

export async function getServerSideProps(context) {
  const { params } = context;
  const headerApi = getHeader(context.req.headers);
  const exploreApi = getExplore(context.req.headers);
  const identityApi = getIdentity(context.req.headers);
  const plansApi = getPriceTable(context.req.headers);

    try {
    const [header, explore, school, community, identity, plans] = await Promise.all([
      headerApi,
      exploreApi,
      getSchool(params.slug),
      getCommunityInfo(params.slug),
      identityApi,
      plansApi,
    ]);

    return {
      props: {
        preloadedState: {
          initialState: {
            header: header.data,
            explore: explore.data.data,
            school: school.data,
            community: community.data,
            identity: identity.data,
            plans: plans?.data?.data ?? {},
          },
          i18n: translationsParser('escuela', params.locale),
          metatags: {
            ...school.data.metaInfo,
            canonical: `${header.data.canonical}/escuela/${params.slug}/`,
          },
        },
      },
    };
  } catch (error) {
    return {
      redirect: {
        destination: `/${params.slug}`,
        permanent: false,
      },
    };
  }
}

const School = () => {
  return <LayoutCommunity />;
};

export default School;
